import { graphql } from "@/types/gql";

export const QUERY_CITY = graphql(`
  query GetCity($cityId: String!) {
    city(id: $cityId) {
      id
      name
      zipCode
      details {
        departement
        surfaceArea
        state
        country
        countryCode
        osmId
        dataProvider {
          name
          deviceIds
        }
        currency {
          code
          symbol
        }
        timezone {
          iana
        }
      }
      position
      image
      boundaries
    }
  }
`);

export const QUERY_PAGINATED_CITIES = graphql(`
  query PaginatedCities(
    $filter: [FilterInput!]
    $pageIndex: Int!
    $pageSize: Int!
    $sortOrder: SortOrder
    $sortField: String
  ) {
    paginatedCities(
      filter: $filter
      pageIndex: $pageIndex
      pageSize: $pageSize
      sortOrder: $sortOrder
      sortField: $sortField
    ) {
      results {
        id
        name
        zipCode
        details {
          departement
          surfaceArea
          state
          country
          countryCode
          osmId
          dataProvider {
            name
            deviceIds
          }
          options {
            live
            offstreet
            payment
            curbZones
            mapIntegration
            decreeAnalysis {
              enabled
              emailFrom
              emailTo
            }
            wazeFeedUrl
            mobileMap
          }
          currency {
            code
            symbol
          }
          timezone {
            iana
          }
        }
        position
        image
        boundaries
      }
      totalPages
    }
  }
`);

export const QUERY_CITY_LIST = graphql(`
  query GetSimplifiedCities {
    cities {
      id
      name
      position
    }
  }
`);

export const QUERY_CREATE_CITY = graphql(`
  mutation addCity($city: CreateCityInput!) {
    createCity(createCityInput: $city) {
      id
    }
  }
`);

export const QUERY_UPDATE_CITY = graphql(`
  mutation updateCity($city: UpdateCityInput!) {
    updateCity(updateCityInput: $city) {
      id
    }
  }
`);

export const QUERY_REMOVE_CITY = graphql(`
  mutation removeCity($cityId: String!) {
    removeCity(id: $cityId) {
      id
    }
  }
`);

export const QUERY_OFF_STREET_PARKINGS = graphql(`
  query OffStreetParkings($cityId: String!, $boundingBox: [[Float!]!]) {
    offStreetParkings(cityId: $cityId, boundingBox: $boundingBox) {
      id
      name
      address
      location
      totalPlaces
    }
  }
`);

export const QUERY_OFF_STREET_PARKING = graphql(`
  query OffStreetParking($cityId: String!, $id: String!) {
    offStreetParking(cityId: $cityId, id: $id) {
      id
      name
      address
      externalId
      cityId
      location
      totalPlaces
      pricePerHour
      otherAdresses
      maxHeight
      levels
      layout
      options {
        evChargers
        toilets
        disabledAccess
        disabledPlaces
        motorcycleAccess
        motorcyclePlaces
        bicycleAccess
        bicyclePlaces
      }
      openingHours {
        startDate
        endDate
        daysOfWeek
        daysOfMonth
        months
        timeOfDayStart
        timeOfDayEnd
        designatedPeriod
        designatedPeriodExcept
      }
    }
  }
`);

export const QUERY_ADD_OFF_STREET_PARKING = graphql(`
  mutation createOffStreetParking($input: CreateOffStreetParkingInput!) {
    createOffStreetParking(input: $input) {
      id
      name
      address
      externalId
      cityId
      location
      totalPlaces
      pricePerHour
      otherAdresses
      maxHeight
      levels
      layout
      options {
        evChargers
        toilets
        disabledAccess
        disabledPlaces
        motorcycleAccess
        motorcyclePlaces
        bicycleAccess
        bicyclePlaces
      }
      openingHours {
        startDate
        endDate
        daysOfWeek
        daysOfMonth
        months
        timeOfDayStart
        timeOfDayEnd
        designatedPeriod
        designatedPeriodExcept
      }
    }
  }
`);

export const QUERY_UPDATE_OFF_STREET_PARKING = graphql(`
  mutation updateOffStreetParking($input: UpdateOffStreetParkingInput!) {
    updateOffStreetParking(input: $input) {
      id
      name
      address
      externalId
      cityId
      location
      totalPlaces
      pricePerHour
      otherAdresses
      maxHeight
      levels
      layout
      options {
        evChargers
        toilets
        disabledAccess
        disabledPlaces
        motorcycleAccess
        motorcyclePlaces
        bicycleAccess
        bicyclePlaces
      }
      openingHours {
        startDate
        endDate
        daysOfWeek
        daysOfMonth
        months
        timeOfDayStart
        timeOfDayEnd
        designatedPeriod
        designatedPeriodExcept
      }
    }
  }
`);

export const QUERY_REMOVE_OFF_STREET_PARKING = graphql(`
  mutation deleteOffStreetParking($id: String!) {
    deleteOffStreetParking(id: $id) {
      id
    }
  }
`);

export const QUERY_PUBLISH_MAP = graphql(`
  mutation PublishCitiesTiles {
    publishCitiesTiles {
      citiesBoundariesTilesetId
      citiesCurbZoneParkingTilesetId
    }
  }
`);
